import React, {Component} from 'react'
import {connect} from 'react-redux';

import {bindActionCreators} from "redux";

/*import {GoogleSignin} from "react-native-google-signin";
import {AccessToken, LoginManager} from "react-native-fbsdk";*/
// import './signin_old.css'
import './../../styles/css/screens/SignIn/sign-in.css'
// import './signin_320.css'
import Firebase from 'firebase'
import {getResponsiveStyles, FirebaseUtils,CricrushConfig, colors, CCHB, CCButton, CCInput, strings, CCActions} from "./../../cc-imports";

import PropTypes from 'prop-types';
import {Constants} from "../../config";
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
class SignIn extends Component {

    static propTypes = {
        onSignInSuccess : PropTypes.func
    }

    static defaultProps = {
        onSignInSuccess : ()=>{}
    }

    constructor(props) {
        super(props)
        this.initialState = {
            fbLoading: false,
            gglLoading: false,
            emailLoading: false,

            error : null,

            email: '',
            password: '',
            displayName: ''
        }
        this.state = {
            showSignIn: true,
            ...this.initialState
        }

        this._closeModal = this._closeModal.bind(this);
        this._showSignUp = this._showSignUp.bind(this);
        this._showSignIn = this._showSignIn.bind(this);

        this._fbSignOn = this._fbSignOn.bind(this);
        this._gglSignOn = this._gglSignOn.bind(this);
        this._emailSignIn = this._emailSignIn.bind(this);
        this._emailSignUp = this._emailSignUp.bind(this);

        this._toggleLoading = this._toggleLoading.bind(this);
        this._signOnError = this._signOnError.bind(this);
        this._signOnSuccess = this._signOnSuccess.bind(this);
    }

    _closeModal() {
        this.props.actions.closeModal("SignIn");
    }

    _showSignUp() {
        this.setState({showSignIn: false});
    }

    _showSignIn() {
        this.setState({showSignIn: true});
    }
    

    componentDidMount() {
        this._setupGoogleSignin();
    }

    _setupGoogleSignin() {
        /*GoogleSignin.hasPlayServices({
            //load prod configs
            autoResolve: true
        }).then(() => {
            GoogleSignin.configure(CricrushConfig.googleSigninConfig);
            const user = GoogleSignin.currentUserAsync();
        })
            .catch((err) => {
                //console.log(err)
            })*/
    }

    _toggleLoading(type, value) {
        switch (type) {
            case 'fb':
                this.setState({fbLoading: value});
                break;
            case 'ggl':
                this.setState({gglLoading: value});
                break;
            case 'email':
                this.setState({emailLoading: value});
                break;
            default:
                this.setState({fbLoading:value,gglLoading:value,emailLoading:value})
        }
    }


    _signOnSuccess(user) {

        this._toggleLoading('all', false);
        this.setState({error : null});

        const url_string = window.location.href; //window.location.href
        const url = new URL(url_string);
        const invitedById = url.searchParams.get("invitedBy");

        const linkParams = invitedById;

        if(user) {
            Firebase.auth().currentUser.getIdToken(false).then((idToken)=>{
                var createUser ={ email : user.email, accessToken : idToken };

                if(linkParams){
                    createUser.invitedBy = {id : linkParams};
                }
                if(this.state.displayName && this.state.displayName.length>0){
                    createUser.displayName = this.state.displayName;
                }
                //console.log("-- -- -- -- -- -- -- ", createUser)
                this.props.actions.getOrCreateUserByEmail(createUser, idToken).then(()=>{
                    this.props.onSignInSuccess();
                }).catch(()=>{
                    this.props.onSignInSuccess();
                })
            }).catch(()=>{
                this.props.onSignInSuccess();
            })
        }
        else {
            this.props.onSignInSuccess();
        }

        //link failed providers with new user signedin
        if(this.props.user.failedCredentials && this.props.user.failedCredentials.length>0){
            FirebaseUtils.linkProviders(this.props.user.failedCredentials)
        }

    }

    _signOnError(error) {
        this._toggleLoading('all', false);
        this.setState({error : error});
    }

    _fbSignOn() {
        this._toggleLoading('fb', true);
       /* LoginManager.logInWithReadPermissions(['public_profile', 'email', 'user_friends']).then(
            function (result) {
                if (result.isCancelled) {

                } else {
                    AccessToken.getCurrentAccessToken().then(
                        (data) => {
                            FirebaseUtils.signOnFb(data.accessToken, this._signOnSuccess, this._signOnError, this.props.actions);
                        }
                    )
                }
            }.bind(this),
            function (error) {
                this._toggleLoading('fb', false);
            }
        );*/
        var provider = new Firebase.auth.FacebookAuthProvider();
        FirebaseUtils.signOnFb(provider, this._signOnSuccess, this._signOnError, this.props.actions);
    }

    _gglSignOn() {
        this._toggleLoading('ggl', true);
        var provider = new Firebase.auth.GoogleAuthProvider();
        FirebaseUtils.signOnGgl(provider, this._signOnSuccess, this._signOnError, this.props.actions);
    }

    _emailSignIn() {
        this._toggleLoading('email', true);
        FirebaseUtils.signInEmail({email : this.state.email, password:this.state.password}, this._signOnSuccess, this._signOnError, this.props.actions);
    }

    _emailSignUp() {
        this._toggleLoading('email', true);
        FirebaseUtils.signUpEmail({email : this.state.email, password:this.state.password, displayName:this.state.displayName}, this._signOnSuccess, this._signOnError, this.props.actions);
    }



    render() {
        const styles = ccStyles.default;
        return (
            <CCErrorBoundary>
                <div className={'flex-container'} style={{flex:1, flexDirection:'column'}}>
                    {
                        this.state.showSignIn ?
                            <div className={'flex-container sign-in-parent'} >
                                <div className={'flex-container sign-in-title-div'}>
                                    <h2 className={'sign-in-title'} onClick={this._showSignUp}>{strings('do_not_have_an_account')}</h2>
                                    <h2 className={'sign-in-title sign-in-title-btn'} onClick={this._showSignUp}>{strings('register_here')}</h2>
                                </div>
                                <div className={'sign-in-social-div'}>
                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event:'FacebookSignIn'}} type={"fb_signin"} onPress={this._fbSignOn} loading={this.state.fbLoading}/>
                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event:'GoogleSignIn'}} type={"ggl_signin"} style={{marginTop: 5}} onPress={this._gglSignOn} loading={this.state.gglLoading}/>
                                </div>
                                <div className={'flex-container sign-in-or-div'} >
                                    <h1 className={'sign-in-or-text'}>{strings('or')}</h1>
                                </div>
                                <div className={'sign-in-form-div'}>
                                    <CCInput immediate={true} label={strings('email')}type={"email"} onEndEditing={(email) => {this.setState({email})}}/>
                                    <CCInput immediate={true} label={strings('password')} type={"password"} onEndEditing={(password) => {this.setState({password})}}/>

                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event:'ManualSignIn'}} title={strings('login')} style={{marginTop: 5}}
                                              onPress={this._emailSignIn} loading={this.state.emailLoading}/>
                                </div>
                            </div>
                            :
                            <div className={'flex-container sign-in-parent'}>
                                <div className={'flex-container sign-in-title-div'}>
                                    <h2 className={'sign-in-title'} onClick={this._showSignIn}>{strings('already_registered')} </h2>
                                    <h2 className={'sign-in-title sign-in-title-btn'} onClick={this._showSignIn}>{strings('login_here')}</h2>
                                </div>
                                <div className={'sign-in-social-div'}>
                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event:'FacebookSignUp'}} type={"fb_signup"} onPress={this._fbSignOn} loading={this.state.fbLoading}/>
                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event:'GoogleSignUp'}} type={"ggl_signup"} style={{marginTop: 5}} onPress={this._gglSignOn} loading={this.state.gglLoading}/>
                                </div>
                                <div className={'flex-container sign-in-or-div'}>
                                    <h2 className={'sign-in-or-text'}>{strings('or')} </h2>
                                </div>
                                <div className={'sign-in-form-div'}>
                                    <CCInput immediate={true} label={strings('display_name')} onEndEditing={(displayName) => {
                                        //console.log(displayName);
                                        this.setState({displayName})
                                    }}/>
                                    <CCInput immediate={true} label={strings('email')} type={"email"} onEndEditing={(email) => {
                                        //console.log(email);
                                        this.setState({email})
                                    }}/>
                                    <CCInput  immediate={true} label={strings('password')} type={"password"} onEndEditing={(password) => {
                                        //console.log(password);
                                        this.setState({password})
                                    }}/>
                                    <CCButton className={'sign-in-btn'} titleClassName={'sign-in-btn-txt'} analytics={{event : 'ManualSignUp'}} title={strings('create_account')} style={{marginTop: 5}} onPress={this._emailSignUp} loading={this.state.emailLoading}/>
                                </div>
                            </div>
                    }
                    <div className={'flex-container'} style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                        <h1 className={'sign-in-btn-txt'} style={{width:'80%'}} >{this.state.error}</h1>
                    </div>
                </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user,

    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(SignIn);


const ccStyles ={
    default:{
        title : {
            fontSize:15
        }
    },
    s : {
        title : {
            fontSize:12
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/screens/SignIn/SignIn.js